import { render, staticRenderFns } from "./MultiVanPage.vue?vue&type=template&id=9485f0ac&"
import script from "./MultiVanPage.vue?vue&type=script&lang=js&"
export * from "./MultiVanPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports